import { createRoot } from 'react-dom/client';
import DatePickerWrapper from './DatePickerWrapper';

class DateFilter {
	constructor(eventDateFilter) {
		this.eventDateFilter = eventDateFilter;
		this.datePickerButton = eventDateFilter.querySelector(
			'.filter-date__date-picker-button'
		);
		this.datePickerInput = eventDateFilter.querySelector(
			'.filter-date__date-picker-input'
		);
		this.datePicker = eventDateFilter.querySelector(
			'.filter-date__date-picker'
		);
		this.todayButton = eventDateFilter.querySelector(
			'.filter-date__today-button'
		);
		this.previousButton = eventDateFilter.querySelector(
			'.filter-date__nav-button--previous'
		);
		this.nextButton = eventDateFilter.querySelector(
			'.filter-date__nav-button--next'
		);
		this.monthView =
			eventDateFilter.classList.contains('filter-date--month');

		this.root = createRoot(this.datePicker);

		this.initialMonth =
			this.eventDateFilter.getAttribute('data-initial-month');
		this.initialYear =
			this.eventDateFilter.getAttribute('data-initial-year');
		this.currentMonth =
			this.eventDateFilter.getAttribute('data-current-month');
		this.currentYear =
			this.eventDateFilter.getAttribute('data-current-year');
		this.lastMonth =
			this.eventDateFilter.getAttribute('data-last-month') ??
			new Date().getFullYear() + 1;
		this.lastYear =
			this.eventDateFilter.getAttribute('data-last-year') ??
			new Date().getMonth();

		if (this.datePickerButton) {
			this.datePickerButton.addEventListener(
				'click',
				this.toggleDatePicker.bind(this)
			);
		}

		if (this.todayButton) {
			this.todayButton.addEventListener(
				'click',
				this.resetDatePicker.bind(this)
			);
		}

		if (this.monthView) {
			this.checkButtonStatus();

			this.previousButton.addEventListener(
				'click',
				this.changeMonth.bind(this)
			);

			this.nextButton.addEventListener(
				'click',
				this.changeMonth.bind(this)
			);
		} else {
			this.previousButton.addEventListener(
				'click',
				this.togglePagination.bind(this)
			);

			this.nextButton.addEventListener(
				'click',
				this.togglePagination.bind(this)
			);
		}

		this.block = this.datePicker.closest('.acf-block');

		this.postsWrapper = this.block?.querySelector(
			'.block-filter__posts-wrapper'
		);

		const pagination = this.block?.querySelector('.filter-pagination');

		if (pagination) {
			if (pagination.querySelector('.current:not(:first-child)')) {
				this.previousButton.removeAttribute('disabled');
			}

			if (pagination.querySelector('.current:not(:last-child)')) {
				this.nextButton.removeAttribute('disabled');
			}
		}

		window.addEventListener(
			'propel-filters-render-posts',
			this.checkButtonStatus.bind(this)
		);

		this.renderDatePicker();
	}

	renderDatePicker() {
		this.root.render(
			<DatePickerWrapper
				datePicker={this.datePicker}
				datePickerInput={this.datePickerInput}
				datePickerButton={this.datePickerButton}
				monthView={this.monthView}
				initialMonth={this.initialMonth}
				initialYear={this.initialYear}
				currentMonth={this.currentMonth}
				currentYear={this.currentYear}
				lastMonth={this.lastMonth}
				lastYear={this.lastYear}
			/>
		);
	}

	toggleDatePicker() {
		const toggleEvent = new CustomEvent('propel-toggle-date-picker');
		this.datePicker.dispatchEvent(toggleEvent);
	}

	resetDatePicker() {
		const resetEvent = new CustomEvent('propel-reset-date-picker');
		this.datePicker.dispatchEvent(resetEvent);
	}

	togglePagination(e) {
		e.currentTarget.setAttribute('disabled', 'disabled');

		let eventName = 'propel-filters-next-page';

		if (
			e.currentTarget.classList.contains(
				'filter-date__nav-button--previous'
			)
		) {
			eventName = 'propel-filters-previous-page';
		}

		const paginationEvent = new CustomEvent(eventName, {
			detail: {
				datePicker: this.datePicker,
				postsWrapper: this.postsWrapper,
			},
		});
		window.dispatchEvent(paginationEvent);
	}

	changeMonth(e) {
		let eventName = 'propel-filters-next-month';

		this.previousButton.setAttribute('disabled', 'disabled');
		this.nextButton.setAttribute('disabled', 'disabled');

		if (
			e.currentTarget.classList.contains(
				'filter-date__nav-button--previous'
			)
		) {
			eventName = 'propel-filters-previous-month';
		}

		const paginationEvent = new CustomEvent(eventName, {
			detail: {
				datePicker: this.datePicker,
			},
		});
		window.dispatchEvent(paginationEvent);
	}

	checkButtonStatus(e = null) {
		if (this.monthView) {
			const previousYearButton = this.datePicker?.querySelector(
				'.filter-month-picker__nav-button'
			);
			const previousMonthButton = this.datePicker?.querySelector(
				'.filter-month-picker__button--active'
			)?.previousElementSibling;

			if (!previousYearButton && !previousMonthButton) {
				if (
					this.initialYear === this.currentYear &&
					this.initialMonth > this.currentMonth
				) {
					this.previousButton.removeAttribute('disabled');
				} else if (this.initialYear > this.currentYear) {
					this.previousButton.removeAttribute('disabled');
				} else {
					this.previousButton.setAttribute('disabled', 'disabled');
				}
			} else if (
				!previousYearButton?.disabled ||
				!previousMonthButton?.disabled
			) {
				this.previousButton.removeAttribute('disabled');
			} else {
				this.previousButton.setAttribute('disabled', 'disabled');
			}

			this.nextButton.removeAttribute('disabled');

			return;
		}

		if (e?.detail?.currentPage > 1) {
			this.previousButton.removeAttribute('disabled');
		} else {
			this.previousButton.setAttribute('disabled', 'disabled');
		}

		if (e?.detail?.currentPage < e?.detail?.maxPages) {
			this.nextButton.removeAttribute('disabled');
		} else {
			this.nextButton.setAttribute('disabled', 'disabled');
		}
	}
}

const eventDateFilters = document.querySelectorAll('.filter-date');

if (eventDateFilters.length > 0) {
	eventDateFilters.forEach((eventDateFilter) => {
		new DateFilter(eventDateFilter);
	});
}
